import React, { useEffect, useState } from "react";
import { X, User, Mail, Phone } from "react-feather";
import Modal from "react-modal";
import ModalContent from "../../../common/Modal/ModalContent";
import Spinner from "../../../common/Spinner/Spinner";
import { Button } from "../../../common/Button/Button";
import api from "../../../utils/api";

export default function FacilitatorThreeSixtyModel(props) {
    const [isLoading, setLoading] = useState(false);
    const [notesEmail, setNotesEmail] = useState("");
    const emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    const phonePattern = /^\d{10}$/;

    // useEffect(() => {
    //     setNotesEmail("");
    //     getProfile();
    // }, [props.facilitatorData])

    const getProfile = async () => {
        setLoading(true);
      
        try {
          let searchFilterParams;
      
          if (!props.searchTerm) {
            throw new Error("Search term is empty");
          }
      
          if (phonePattern.test(props.searchTerm)) {
            searchFilterParams = {
              SearchBy: "contact_number",
              SearchValue: props.searchTerm,
            };
          }
          else if (emailPattern.test(props.searchTerm)) {
            searchFilterParams = {
              SearchBy: "email",
              SearchValue: props.searchTerm,
            };
          }
          else {
            getServices();
           
          }
      
          
            const wp_user = await api
            .getUserProfileWP(searchFilterParams)
            .then((d) => {
                if(d?.data?.data?.[0]?.email){
                    setNotesEmail(d?.data?.data?.[0]?.email);
                }else{
                    getServices();
                }
            });
        } catch (error) {
          console.error("Error fetching profile:", error);
        } finally {
          setLoading(false);
        }
      };

      const getServices=async()=>{
        let searchFilterParams;
        let searchFilterParamsNew ;
          if (phonePattern.test(props.searchTerm)) {
            searchFilterParamsNew = {
                C_phone: props.searchTerm,
            };
        }
        else{
            searchFilterParamsNew = {
                nResourceInstanceID: props.searchTerm,
            };
        }
    
          const { page } = {
              page: 0,
          };
          let sortParams = null;

          const unassigned = null;
          const serviceRequestList = [];
          const PackageList = [];
          const failedPayments = null;
          const statusList = [];
          const paymentStatus = [];
          const followupDates = "";
          const pagination = false;
          const flag = false;
          const data = await api.getAllServiceRequests(page + 1,
              10,
              '',
              '',
              paymentStatus,
              statusList,
              unassigned,
              serviceRequestList,
              failedPayments,
              'all',
              'all',
              PackageList,
              searchFilterParamsNew,
              sortParams,
              flag,
              pagination);
          if(data?.data.length>0){
              setNotesEmail(data?.data?.[0]?.sEmailAddress)
               searchFilterParams = {
                  SearchBy: "email",
                  SearchValue: data.data[0]?.sEmailAddress,
                };
          }
    
          // SPM CALL
          const followupInPast = null;
          const followupToday = null;
          const data1 = await api.getAllServicesSPM(page + 1,
              10,
              paymentStatus,
              statusList,
              unassigned,
              serviceRequestList,
              followupInPast,
              followupToday,
              failedPayments,
              'all',
              PackageList,
              searchFilterParamsNew,
              sortParams,
              flag,
              pagination);
          if(data1.data.length>0){
              setNotesEmail(data1.data[0]?.sEmailAddress)
              let searchFilterParams = {
                  SearchBy: "email",
                  SearchValue: data1.data[0]?.sEmailAddress,
                };
          }
      }
      


    const hasFacilitatorData = props.facilitatorData &&
        (props.facilitatorData.email);

    return (
        <Modal
            isOpen={props.isOpen}
            onRequestClose={props.toggleModal}
            ariaHideApp={false}
        >
            <ModalContent>
                <div className="p-2 modal-headers-bar">

                    <span>Facilitator Details</span>

                    <button
                        type="button"
                        className="close"
                        aria-label="Close"
                        onClick={props.toggleModal}
                    >
                        <X style={{ pointerEvents: "none" }} color="white" />
                    </button>

                </div>

                <div
                    className={`modal-body ${isLoading ? "set-opacity" : ""}`}
                    style={{ overflowY: "auto", height: "200px", }}
                >

                    {isLoading && <Spinner className="top" />}

                    <div style={{ paddingBottom: "5px", marginBottom: "10px" }}>

                        {hasFacilitatorData ? (
                            <div className="list-group list-group-flush">

                                <div className="list-group-item px-0 py-2 d-flex align-items-center">
                                    <User size={18} className="text-muted mr-3" />
                                    <div className="flex-grow-1">
                                        <div className="text-muted small">Name</div>
                                        <div className="font-weight-bold">
                                            {`${props.facilitatorData.first_name || ""} ${props.facilitatorData.last_name || ""}`}
                                        </div>
                                    </div>
                                </div>

                                <div className="list-group-item px-0 py-2 d-flex align-items-center">
                                    <Mail size={18} className="text-muted mr-3" />
                                    <div className="flex-grow-1">
                                        <div className="text-muted small">Email ID</div>
                                        <div className="font-weight-bold">
                                            {props.facilitatorData.email || ""}
                                        </div>
                                    </div>
                                </div>
                                {/* {notesEmail &&
                                    <div className="mt-4">
                                    <Button
                                      onClick={() => props.toggleViewAllNotesModal(notesEmail)}
                                      style={{ float: "left", marginLeft: "10px" }}
                                    >
                                      View All Notes
                                    </Button>
                                  </div>} */}


                            </div>
                        ) : (
                            <div className="p-4 text-center text-muted border rounded bg-light">
                                No Facilitator Details Found
                            </div>
                        )}
                    </div>
                </div>
            </ModalContent>
        </Modal>
    );
}